const Comp = () => {
  return <div>dynaic Comp</div>;
};

export default Comp;
